// --------------------------------------------------------------------------
// #54 - LOAD MORE
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function doesLinkContainInPageAnchor(href) {
        var indexOfAnchor = href.indexOf('#');
        return indexOfAnchor !== -1 && ( // has an anchor (#) in the URL AND
        indexOfAnchor === 0 || // EITHER starts with the anchor
        location.pathname === href.substring(0, indexOfAnchor)); // OR the path of the page is the same
    }

    function bindEventListeners() {
        $(context).on('click', function (e) {
            var $this = $(this);
            var href = $this.attr('href');

            if (doesLinkContainInPageAnchor(href)) {
                var elementId = href.substring(href.indexOf('#') + 1);
                var $element = $('#' + elementId);
                if ($element.length === 1) {
                    e.preventDefault();
                    var offset = $element.offset().top;
                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                } else {
                    return true;
                }
            } else {
                return true;
            }
        });
    }

    function init() {
        bindEventListeners();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/anchor-smooth-scroll.js
// module id = 213
// module chunks = 0